/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Section: About Us
 */

import { Container, Row } from 'react-bootstrap';

// Styles
import './style.scss';

const About = (props) => {
    const {about} = props;

    return(
        <Container>
            <Row>
                <p className="text-center" data-aos="zoom-in">
                    {about.text}
                </p>
            </Row>
        </Container>
    );
}

export default About;